module["exports"] = [
  "com",
  "fr",
  "eu",
  "info",
  "name",
  "net",
  "org"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/fr/internet/domain_suffix.js
 ** module id = 583
 ** module chunks = 0
 **/